import React, { Component } from "react";
import { Table, Tab } from "semantic-ui-react";
import _ from "lodash";
import { connect } from "react-redux";
import SearchResultHeader from "./SearchResultHeader";
import LinkedInDetail from "./LinkedInDetail";
import TwitterDetail from "./TwitterDetail";
import FacebookDetail from "./FacebookDetail";
import GoogleDetail from "./GoogleDetail";
import GooglePlusDetail from "./GooglePlusDetail";
import { getMenuItem } from "../common/PageHelper";

class BusinessSocialResult extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedReportId: null,
    };
  }

  onSelectReport = (selectedReportId) => {
    this.state = { selectedReportId };
  };

  render() {
    const results = [];
    let recCount = 0;
    let tabHeader = null;
    if (
      this.props.searchResultData !== undefined &&
      this.props.searchResultData !== null &&
      this.props.searchResultData !== ""
    ) {
      const records = _.get(
        this.props.searchResultData,
        `${
          Object.keys(this.props.searchResultData)[0]
        }.email[0].results[0].records[0]`
      );
      const showNarrowSearchMessage = records && records.length > 25;
      tabHeader = (
        <SearchResultHeader
          showNarrowSearchMessage={showNarrowSearchMessage}
          log={_.get(
            this.props.searchResultData,
            `${Object.keys(this.props.searchResultData)[0]}.log[0]`
          )}
          {...this.props}
          printContent={this.props.printContent}
        />
      );
      const linkedInRecords = _.get(records, "linkedIn[0].profile");
      const facebookRecords = _.get(records, "facebook[0].person");
      const twitterRecords = _.get(records, "twitter[0].person");
      const googleRecords = _.get(records, "google[0].person");
      const googlePlusRecords = _.get(records, "googlePlus[0].person");
      recCount =
        (linkedInRecords !== undefined ? linkedInRecords.length : 0) +
        (facebookRecords !== undefined ? facebookRecords.length : 0) +
        (twitterRecords !== undefined ? twitterRecords.length : 0) +
        (googleRecords !== undefined ? googleRecords.length : 0) +
        (googlePlusRecords !== undefined ? googlePlusRecords.length : 0);
      if (records !== undefined) {
        results.push(
          <Table.Row key={`Social_LinkedIn_Table_Row`}>
            <Table.Cell>
              <LinkedInDetail node={linkedInRecords} {...this.props} />
            </Table.Cell>
          </Table.Row>
        );
        results.push(
          <Table.Row key={`Social_Facebook_Table_Row`}>
            <Table.Cell>
              <FacebookDetail node={facebookRecords} {...this.props} />
            </Table.Cell>
          </Table.Row>
        );
        results.push(
          <Table.Row key={`Social_Twitter_Table_Row`}>
            <Table.Cell>
              <TwitterDetail node={twitterRecords} {...this.props} />
            </Table.Cell>
          </Table.Row>
        );
        results.push(
          <Table.Row key={`Social_Google_Table_Row`}>
            <Table.Cell>
              <GoogleDetail node={googleRecords} {...this.props} />
            </Table.Cell>
          </Table.Row>
        );
        results.push(
          <Table.Row key={`Social_GooglePlus_Table_Row`}>
            <Table.Cell>
              <GooglePlusDetail node={googlePlusRecords} {...this.props} />
            </Table.Cell>
          </Table.Row>
        );
      }
    }

    const tabs = [];
    const { userAccount } = this.props;
    tabs.push({
      menuItem: getMenuItem(
        userAccount.acctTheme,
        true,
        `${recCount} Matches Found`
      ),
      render: () => (
        <Tab.Pane>
          {tabHeader}
          <Table stackable>
            <Table.Body>{results}</Table.Body>
          </Table>
        </Tab.Pane>
      ),
    });

    return <Tab panes={tabs} />;
  }
}

function mapStateToProps(state) {
  return {
    userAccount: state.userAccount,
  };
}

export default connect(mapStateToProps, null)(BusinessSocialResult);



// WEBPACK FOOTER //
// ./src/components/searchresults/BusinessSocialResult.js